module.exports = __webpack_public_path__ + "static/img/IMG_20160822_150115-EFFECTS.0a11c3d4.jpg";